import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import { TMonthlyFeeDetails } from 'redux/reducers/easFee/types';

export const FEE_CLASS_SELECTOR = 'feeClassId';

export const tableStructure: TTableStructure<keyof TMonthlyFeeDetails>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Name',
		selector: 'name',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Description',
		selector: 'description',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 3,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		tooltip: (item) => item.description ?? '',
	},
	{
		name: 'Name For Invoice',
		selector: 'nameForInvoice',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Dashboard Description',
		selector: 'dashboardDescription',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		tooltip: (item) => item.dashboardDescription ?? '',
	},
	{
		name: 'Value, EUR',
		selector: 'value',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Transaction Fee Class',
		selector: FEE_CLASS_SELECTOR,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Import Orders Threshold',
		selector: 'importOrdersThreshold',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'OSS Orders Threshold',
		selector: 'ossOrdersThreshold',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Show For All',
		selector: 'showForAll',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Discontinued',
		selector: 'discontinued',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Updated At',
		selector: 'updatedAt',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Updated By',
		selector: 'updatedBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [
			{
				name: 'Edit',
				icon: EIconButtons.EDIT,
			},
			{
				name: 'Delete',
				icon: EIconButtons.DELETE,
			},
		],
	},
];
